import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { H3, H5, H6 } from "../../../AbstractElements";
import CountUp from 'react-countup';
import HeaderCard from "../../Common/Component/HeaderCard";
import { enquiryDetails, PaymentCollection, Sale_Details } from "../../../Constant";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FaGlobe } from "react-icons/fa";
import { CONVERTSVG, NewOrderSvg, PendingSvg, WONSVG } from "../../../Data/Widgets/General/Data";
import { svg } from "leaflet";
import wonsvg from '../../../assets/images/Icons/Won.svg'
import convertsvg from '../../../assets/images/Icons/Converted.svg'


const EnquiryProfile = (props) => {
    const authState = useSelector((state) => state.auth);
    const defaultSalesData = [
        {
            id: 1,
            icon: 'icofont icofont-arrow-down font-primary',
            iconClass: 'bg-light-primary',
            link: `${process.env.PUBLIC_URL}/lead-manage/enquiry`,
            fallbackTitle: 'Today',
            class: 'font-primary',
            svg: <div className={`widget-icon bg-light-primary`}>
                <NewOrderSvg />
            </div>
        },
        {
            id: 2,
            icon: 'fa-solid fa-comments font-secondary',
            iconClass: 'bg-light-secondary',
            link: `${process.env.PUBLIC_URL}/lead-manage/leads`,
            fallbackTitle: '',
            class: 'font-secondary',
            svg:
                <div className="widget-icon">
                    <img src={convertsvg} alt="" />
                </div>
        },
        {
            id: 3,
            icon: 'icofont icofont-arrow-up font-success',
            iconClass: 'bg-light-success',
            link: `${process.env.PUBLIC_URL}/lead-manage/leads?stage=won`,
            fallbackTitle: 'Won',
            class: 'font-success',
            svg:
                <div className="widget-icon">
                    <img src={wonsvg} alt="" />
                </div>
        },
        {
            id: 4,
            icon: 'icofont icofont-arrow-up font-success',
            iconClass: 'bg-light-success',
            link: `${process.env.PUBLIC_URL}/lead-manage/overdue-follow-ups`,
            fallbackTitle: 'Overdues',
            class: 'font-success',
            svg: <div className={`widget-icon bg-light-warning`}>
                <PendingSvg/>            </div>
        },
    ];

    const value = props.details || [];

    const SalesData = defaultSalesData.map((item, index) => ({
        ...item,
        title: (
            <Link className="dashboardTableLinks" to={item.link}>
                {value[index]?.status || item.fallbackTitle}
            </Link>
        ),
        counter: value[index]?.count || 0,
    }));


    return (
        <Fragment>
            <Col xl="6" className="box-col-6">
                <Card className="widget-joins widget-arrow">
                    {/* <HeaderCard title={PaymentCollection} setting={true} /> */}
                    <CardHeader className="pb-0">
                        <H3> {enquiryDetails} </H3>
                    </CardHeader>

                    <CardBody>
                        <Row className="gy-4">
                            {SalesData.map((data) => {
                                return (
                                    <Col sm="6" key={data.id}>
                                        <div className="widget-card">
                                            <div className="d-flex align-self-center">
                                                {/* <div className={`widget-icon ${data.iconClass}`}>
                                                    <i className={`${data.icon}`}></i>
                                                </div> */}
                                                <div>
                                                    {
                                                        data?.svg
                                                    }
                                                </div>
                                                <div className="flex-grow-1">
                                                    <H6>{data.title}</H6>
                                                    <H5>
                                                        <span className="counter">
                                                            {data.counter}
                                                            {/* <CountUp end={data.counter} duration={0.8} decimals={2} className="m-0" /> */}
                                                        </span>
                                                        <span className={`${data.class}`}>{data.numbers}</span>
                                                    </H5>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    );
};

export default EnquiryProfile;
